import debounce from 'debounce';

/**
 * Play a sound file.
 *
 * @param {string} sound
 * @param {number} gain
 */
function _playSound(sound: string, gain: number = 1) {
    try {
        const audio = new Audio('/audio/' + sound + '.mp3');
        const audioContext = new AudioContext();
        const gainNode = audioContext.createGain();
        const track = audioContext.createMediaElementSource(audio);
        track.connect(gainNode).connect(audioContext.destination);
        gainNode.gain.value = gain;

        audio.play().catch((e: any) => {
            console.error(e.message);
        });
    }
    catch (e: any) {
        console.error(e.message);
    }
}

const playSound = debounce(_playSound, 1, {immediate: true});

export default playSound;